import {
  ArchiveMessageThread,
  ArchiveMessageThreadVariables,
} from "_graphql/mutation/__generated__/ArchiveMessageThread";
import { MessageView, Modal, OfficeButton } from "components";
import {
  SendTheadMessage,
  SendTheadMessageVariables,
} from "_graphql/mutation/__generated__/SendTheadMessage";
import {
  archiveMessageThread,
  sendPlaceItOfferMessage,
} from "_graphql/place-it/mutations/underwriter.place-it";
import { useAppSearch, useCurrentUser } from "_graphql/cache/auth";

import { placeItClient } from "_graphql";
import toast from "react-hot-toast";
import { useCallback } from "react";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { usePlaceItOfferMessages } from "hooks/data/use-placeit-offers";
import { wrapClick } from "utils";

export default function SendMessageContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const { employee } = useCurrentUser();
  const offerId = searchParams?.id || "";

  const { offers, loading } = usePlaceItOfferMessages({
    offerMessagesId: offerId,
  });

  const [sendMessage, { loading: sendMessageLoading }] = useMutation<
    SendTheadMessage,
    SendTheadMessageVariables
  >(sendPlaceItOfferMessage, {
    refetchQueries: ["Offer_messages"],
    client: placeItClient,
  });

  const [archive, { loading: archiveMessageThreadLoading }] = useMutation<
    ArchiveMessageThread,
    ArchiveMessageThreadVariables
  >(archiveMessageThread, {
    refetchQueries: ["Offer_messages"],
    client: placeItClient,
  });

  const handleArchive = useCallback(async () => {
    try {
      const { data } = await archive({
        variables: {
          offerID: offerId,
          email: employee?.employee_email || "",
        },
      });
      if (data?.archiveMessageThread) {
        toast.success("Message thread archived successfully");
      }
    } catch (error) {}
  }, [archive, offerId, employee?.employee_email]);

  const handleSubmit = useCallback(
    async (values: { message: string }) => {
      try {
        const { data } = await sendMessage({
          variables: {
            offerId,
            message: values.message,
            brokerFirstname: employee?.employee_first_name || "",
            brokerLastname: employee?.employee_last_name || "",
          },
        });

        if (data?.sendTheadMessage?.message) {
          toast.success(data.sendTheadMessage.message);
        }

        form.resetForm();
      } catch (error) {}
    },
    [
      sendMessage,
      offerId,
      employee?.employee_first_name,
      employee?.employee_last_name,
    ]
  );

  const form = useFormik({
    initialValues: {
      message: "",
    },
    onSubmit: handleSubmit,
  });

  const renderActions = useCallback(
    () => (
      <>
        <OfficeButton
          size="sm"
          disabled={sendMessageLoading}
          onClick={wrapClick(form.handleSubmit)}
        >
          {sendMessageLoading ? "Sending..." : "Send"}
        </OfficeButton>
        <OfficeButton
          size="sm"
          disabled={archiveMessageThreadLoading}
          onClick={wrapClick(handleArchive)}
          variant="tertiary"
        >
          {archiveMessageThreadLoading ? "Archiving..." : "Archive"}
        </OfficeButton>
      </>
    ),
    [
      sendMessageLoading,
      form.handleSubmit,
      archiveMessageThreadLoading,
      handleArchive,
    ]
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Offer Message Thread"
      description="Send a message to the offer thread"
      // renderActions={renderActions}
      hideActions
    >
      {/* {form.values.message} */}
      <MessageView offers={offers as Record<string, any>[]} form={form} />
    </Modal>
  );
}
